export default __webpack_public_path__ + "static/media/SoberanoClosed.618671dc.jpg";